<template>
    <div style="height:450px;border-radius:8px" class="card pt-0 mb-3 bg-white px-3 py-3">
        <div class="row">
            <h4 class="card-title pl-3 pb-2 mb-0">Pegawai</h4>
        </div>
        <div class="row no-gutters">
            <div class="col-md-1">
                <hr class="border-primary"/>
            </div>
            <div class="col-md-11">
                <hr/>
            </div>
        </div>
        <div id="chart">
            <apexchart type="donut" height="330" v-if="status == true" :options="chartOptions" :series="series"></apexchart>
        </div>
    </div>
</template>

<script>
export default {
    props: ['tipe', 'jumlah'],
    data() {
        return {
            status: false,
            series: [],
            chartOptions: {
                chart: {
                    width: 330,
                    type: 'donut',
                    dropShadow: {
                        enabled: true,
                        color: '#111',
                        top: -1,
                        left: 3,
                        blur: 3,
                        opacity: 0.2
                    }
                },
                stroke: {
                    width: 0,
                },
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                total: {
                                    showAlways: true,
                                    show: true,
                                    formatter: function (w) {
                                        let vals = w.globals.seriesTotals
                                        var i = 0
                                        let totals = 0
                                        for(i=0;i<vals.length;i++) {
                                            totals += vals[i]
                                        }
                                        let val = totals.toString()
                                        let leng = val.length
                                        let sisa 	= leng % 3
                                        let rupiah 	= val.substr(0, sisa)
                                        let ribuan 	= val.substr(sisa).match(/\d{3}/g)
                                            
                                        if (ribuan) {
                                            let separator = sisa ? '.' : ''
                                            rupiah += separator + ribuan.join('.')
                                        }
                                        return rupiah
                                    }
                                },
                                name: {
                                    show: true,
                                    formatter: function (val) {
                                        return val
                                    }
                                },
                                value: {
                                    show: true,
                                    formatter: function (val) {
                                        let value = val.toString()
                                        let leng = value.length
                                        let sisa 	= leng % 3
                                        let rupiah 	= value.substr(0, sisa)
                                        let ribuan 	= value.substr(sisa).match(/\d{3}/g)
                                            
                                        if (ribuan) {
                                            let separator = sisa ? '.' : ''
                                            rupiah += separator + ribuan.join('.')
                                        }
                                        return rupiah
                                    }
                                },
                            }
                        }
                    }
                },
                labels: [],
                dataLabels: {
                    dropShadow: {
                        blur: 3,
                        opacity: 0.8
                    }
                },
                states: {
                    hover: {
                        filter: 'none'
                    }
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'right'
                        }
                    }
                }]
            },
        }
    },
    watch: {
        tipe() {
            this.getDataPegawai()
        },
        jumlah() {
            this.getDataPegawai()
        },
    },
    methods: {
        getDataPegawai() {
            this.series = this.jumlah
            this.chartOptions.labels = []
            let onPush = []
            let data = this.tipe
            var i = 0
            for(i=0;i<data.length;i++) {
                onPush.push(data[i].split(" (")[0])
            }
            this.chartOptions.labels = onPush
            this.status = true
        }
    },
    mounted() {
        // this.getDataPegawai()
    },
}
</script>
<style scoped>
.card-title {
    font-size: 18px;
    color: rgba(0, 0, 0, 1);
}
</style>